import { render, staticRenderFns } from "./BaseTableSelectActionsForm.vue?vue&type=template&id=10566bfe&scoped=true"
import script from "./BaseTableSelectActionsForm.vue?vue&type=script&lang=js"
export * from "./BaseTableSelectActionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10566bfe",
  null
  
)

export default component.exports